export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-background-200/70 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <a href="#home" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-to-br from-primary-500 to-accent-500 text-background-50">
                <i className="ri-magic-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
                奇妙<span className="text-primary-500">漫画</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-700">
              专注奇幻脑洞内容，汇集异世界穿越、魔法战斗、脑洞冒险等热门题材。更新快、分类全，满足你对奇妙漫画奇幻世界的所有想象。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href="#home"
                aria-label="微博"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-background-300 text-foreground-700 transition-colors hover:border-primary-500 hover:text-primary-500"
              >
                <i className="ri-weibo-line"></i>
              </a>
              <a
                href="#home"
                aria-label="哔哩哔哩"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-background-300 text-foreground-700 transition-colors hover:border-primary-500 hover:text-primary-500"
              >
                <i className="ri-bilibili-line"></i>
              </a>
              <a
                href="#home"
                aria-label="微信公众号"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-background-300 text-foreground-700 transition-colors hover:border-primary-500 hover:text-primary-500"
              >
                <i className="ri-wechat-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-foreground-950">快速导航</h3>
            <ul className="mt-4 space-y-2.5">
              {[
                { href: "#ranking", label: "人气榜单" },
                { href: "#category", label: "题材分类" },
                { href: "#latest", label: "最新更新" },
                { href: "#faq", label: "常见问题" },
                { href: "#subscribe", label: "追漫订阅" },
              ].map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-sm text-foreground-700 transition-colors hover:text-primary-500"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-foreground-950">热门题材</h3>
            <ul className="mt-4 space-y-2.5">
              {["异世界穿越", "魔法战斗", "脑洞冒险", "悬疑惊悚", "热血少年"].map((t) => (
                <li key={t}>
                  <a
                    href="#category"
                    className="text-sm text-foreground-700 transition-colors hover:text-primary-500"
                  >
                    {t}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200/70 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-600">
            © {year} 奇妙漫画 版权所有 · 本网站内容仅供展示参考
          </p>
          <p className="text-xs text-foreground-600">
            联系邮箱：support@qimiao.readdy.site
          </p>
        </div>
      </div>
    </footer>
  );
}